query GetEmailSyncPotentialContacts {
    getEmailSyncPotentialContacts {
        emailAddress {
            display
            address
        }
        lastContactedTime
    }
}
